/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import { IMessagesRepository } from '../repositories/IMessages.repository';
import {
  MOCK_REVIEWS_API_LIST,
  TEST_GBMMESSAGE_LIST,
  TEST_GBM_CONVERSATION_LIST,
  TEST_LEAD_API_LIST,
} from './messages.data';
import { ILeadApi, ILeadsApi } from '../models/Leads-api.properties';
import {
  IReviewApi,
  IReviewLink,
  IReviewsApi,
  IReviewUpsertApi,
} from '../models/Reviews-api.properties';
import {
  IGBMConversationListApi,
  IGBMConversationMessageListApi,
  IGBMConversationMessageReplyApi,
} from '../models/GBMessages-api.properties';
import { delay, dematerialize, materialize } from 'rxjs/operators';

@Injectable()
export class MockMessagesRepository implements IMessagesRepository {
  readonly responseError: IHttpBasicResponse<null> = {
    status: 'error',
    message: 'Some bad error!',
    statusCode: 500,
  };

  constructor() {}

  replyGBMMessage(
    conversationId: string,
    message: string
  ): Observable<IHttpBasicResponse<IGBMConversationMessageReplyApi>> {
    console.warn('***************> MockMessagesRepository::replyGBMMessage()');

    const responseOk = of(null);

    const responseError = throwError(
      (this.responseError.message = 'Method not implemented.')
    );

    return (false ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }

  getLeads(): Observable<JsonApiResponse<ILeadsApi>> {
    console.warn('***************> MockMessagesRepository::getLeads()');
    const response: JsonApiResponse<ILeadsApi> = {
      data: {
        id: '123',
        type: 'leads',
        attributes: FAKE_LEADS_API_PAYLOAD,
      },
    };

    const responseOk = of(response);

    const responseError = throwError(this.responseError);

    return (true ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }

  getReviewLink(): Observable<JsonApiResponse<IReviewLink>> {
    console.warn('***************> MockMessagesRepository::getReviewLink()');
    const response: JsonApiResponse<IReviewLink> = {
      data: {
        id: '123',
        type: 'leads',
        attributes: null,
      },
    };

    const responseOk = of(response);

    const responseError = throwError(this.responseError);

    return (true ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }

  setLeadAsRead(id: number): Observable<JsonApiResponse<ILeadApi>> {
    console.warn('***************> MockMessagesRepository::setLeadAsRead()');
    const data: ILeadApi = TEST_LEAD_API_LIST[0];
    data.read_status = 'READ';

    const responseOk: JsonApiResponse<ILeadApi> = {
      data: {
        attributes: data,
        id: null,
        type: 'leads',
      },
    };

    return of(responseOk);
  }

  getReviews() {
    console.warn('***************> MockMessagesRepository::getReviews()');
    const data = MOCK_REVIEWS_API_LIST as IReviewsApi;

    const responseOk = of({
      data,
      status: 'success',
    } as IHttpBasicResponse<IReviewsApi>);

    const responseError = throwError(this.responseError);

    return (true ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }

  getReview() {
    console.warn('***************> MockMessagesRepository::getReview()');
    const data = MOCK_REVIEWS_API_LIST.reviews[0] as IReviewApi;

    const responseOk: IHttpBasicResponse<IReviewApi> = {
      data,
      status: 'success',
    };

    return of(responseOk);
  }

  upsertReply(id, comment) {
    console.warn('***************> MockMessagesRepository::upsertReply()');
    const data = {
      comment,
      updateTime: new Date().toUTCString(),
    } as IReviewUpsertApi;

    const responseOk: IHttpBasicResponse<IReviewUpsertApi> = {
      data,
      status: 'success',
    };

    return of(responseOk);
  }

  deleteReply(id) {
    console.warn('***************> MockMessagesRepository::deleteReply()');
    const responseOk: IHttpBasicResponse<null> = {
      data: null,
      status: 'success',
    };

    return of(responseOk);
  }

  
  getNotifications() {
    console.warn('***************> MockMessagesRepository::getNotifications()');
    const data = MOCK_REVIEWS_API_LIST as any;

    const responseOk = of({
      data,
      status: 'success',
    } as IHttpBasicResponse<any>);

    const responseError = throwError(this.responseError);

    return (true ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }

  setNotificationAsRead(id: number): Observable<JsonApiResponse<any>> {
    console.warn('***************> MockMessagesRepository::setNotificationAsRead()');
    const data: any = '';
    data.read_status = 'READ';

    const responseOk: JsonApiResponse<any> = {
      data: {
        attributes: data,
        id: null,
        type: 'Notifications',
      },
    };

    return of(responseOk);
  }

  deleteNotification(id) {
    console.warn('***************> MockMessagesRepository::deleteNotification()');
    const responseOk: IHttpBasicResponse<null> = {
      data: null,
      status: 'success',
    };

    return of(responseOk);
  }

  getGBMConversationList(): Observable<
    IHttpBasicResponse<IGBMConversationListApi>
  > {
    console.warn(
      '***************> MockMessagesRepository::getGBMConversationList()'
    );

    const data: IGBMConversationListApi = TEST_GBM_CONVERSATION_LIST;

    const responseOk = of({
      data,
      status: 'success',
    } as IHttpBasicResponse<IGBMConversationListApi>);

    const responseError = throwError(this.responseError);

    return (true ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }
  getGBMMessageList(
    conversationId: string
  ): Observable<IHttpBasicResponse<IGBMConversationMessageListApi>> {
    console.warn(
      '***************> MockMessagesRepository::getGBMMessageList() conversationId',
      conversationId
    );

    const data: IGBMConversationMessageListApi = {
      ...TEST_GBMMESSAGE_LIST,
      attributes: [
        ...TEST_GBMMESSAGE_LIST.attributes.filter(
          (conv) =>
            (conv?.conversation_id ?? '').toString() ===
            conversationId.toString()
        ),
      ],
    };

    const responseOk = of({
      data,
      status: 'success',
    } as IHttpBasicResponse<IGBMConversationMessageListApi>);

    const responseError = throwError(this.responseError);

    return (true ? responseOk : responseError).pipe(
      materialize(),
      delay(1400),
      dematerialize()
    );
  }
}

export const FAKE_LEADS_API_PAYLOAD: ILeadsApi = [
  {
    id: 79,
    name: 'Carlos',
    message: 'Need a quote',
    email: 'dnlmoya@gmail.com',
    phone: '5614800034',
    timestamp: '2021-03-12 11:16:17',
    read_status: 'NEW',
  },
  {
    email: 'avb@virket.com',
    id: 13,
    message: 'probando los Lead messages',
    name: 'andres',
    phone: '7771001154',
    read_status: 'NEW',
    timestamp: '2021-10-06T23:50:47.000000Z',
  },
];
